import { render } from "./ItemRegister.vue?vue&type=template&id=0a8fcd48"
import script from "./ItemRegister.vue?vue&type=script&lang=js"
export * from "./ItemRegister.vue?vue&type=script&lang=js"

import "./ItemRegister.vue?vue&type=style&index=0&id=0a8fcd48&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__